<!-- Zweck: Stellt die HTML-Struktur für main menu button component im Frontend bereit. -->
<button (click)="click()" [class.active]="active" [disabled]="disabled" class="mainmenubutton tut_menu_button" mat-button>
  <svg-icon>menue</svg-icon>
  MENÜ
</button>
